/** Client logging: the one place the web app writes to the console (the rest of the code may not, Biome noConsole). */

/** Logs an error with its scope and a short id the user can quote. */
export function logError(scope: string, err: unknown): void {
  // biome-ignore lint/suspicious/noConsole: the client's single log sink
  console.error(`[${scope}]`, err);
}
